import {Component, Inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA} from "@angular/material/snack-bar";

@Component({
  selector: 'app-persistent-info-snackbar',
  imports: [],
  templateUrl: './persistent-info-snackbar.component.html',
  styleUrl: './persistent-info-snackbar.component.scss',
})
export class PersistentInfoSnackbarComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: { message: string }) {}
}
